"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_difference_1 = __importDefault(require("lodash.difference"));

function difference(collection, values) {
  return lodash_difference_1.default(collection, values);
}

exports.difference = difference;